import type { ReactNode } from 'react';
import { useI18n } from '../../i18n';

type FiltersPanelProps = {
	isOpen: boolean;
	children: ReactNode;
	onApply?: () => void;
	onReset?: () => void;
	className?: string;
	footerContent?: ReactNode;
};

export default function FiltersPanel({
	isOpen,
	children,
	onApply,
	onReset,
	className = '',
	footerContent
}: FiltersPanelProps) {
	const { language } = useI18n();
	const copy = (en: string, de: string, hr: string) =>
		language === 'de' ? de : language === 'hr' ? hr : en;

	if (!isOpen) {
		return null;
	}

	const showFooter = Boolean(onApply || onReset || footerContent);

	return (
		<div className={`card card-body mb-4 ${className}`}>
			<div className="filters-panel__content">{children}</div>
			{showFooter && (
				<div className="d-flex flex-wrap justify-content-end gap-2 mt-3">
					{footerContent}
					{onReset && (
						<button type="button" className="btn btn-outline-secondary" onClick={onReset}>
							{copy('Reset', 'Zurücksetzen', 'Resetiraj')}
						</button>
					)}
					{onApply && (
						<button type="button" className="btn btn-success" onClick={onApply}>
							{copy('Apply', 'Anwenden', 'Primijeni')}
						</button>
					)}
				</div>
			)}
		</div>
	);
}

